import React from "react"
import badge from "badges/solving-problems.svg"
import { BadgeImage } from "backpack/badges/styled"

const SolvingProblems = props => <BadgeImage src={badge} {...props} />

export default SolvingProblems
